import React from "react";

const FailedOfferTable = ({ userInfo }) => {
  const { giftcardListFailed } = userInfo;

  return (
    <div className="gcotg-table failed-table">
      <div className="failed-table-header">
        <h3>
          Failed Offers
        </h3>
        <p className="failed-offers-message">
          These offers have failed. Please{" "}
          <a href={
            "mailto:cs@giftcardselection.com?subject=Failed Offers for Ak-Chin guest #" +
            userInfo.rewardsId + "&body=Please assist me with the following failed offer codes: " +
            giftcardListFailed?.map((giftCard) => `#${giftCard.ticketId}`).join(" ")}>
            email customer service
          </a> with the failed offer code(s) for assistance.
        </p>
      </div>
      <table className="table">
        <thead className="tablehead">
        <tr>
          <th scope="col">Swipe Date</th>
          <th scope="col">Offer Code</th>
          <th scope="col">Brand</th>
          <th scope="col">Amount</th>
        </tr>
        </thead>

        <tbody>
        {giftcardListFailed?.map((giftCard) => (
          <tr key={giftCard.awardId}>
            <td>{giftCard.swipeDate}</td>
            <td>
              {giftCard.ticketId ? giftCard.ticketId : "Failed"}
              </td>
              <td>{giftCard.promotionName}</td>
              <td> ${giftCard.price}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default FailedOfferTable;
